//import React from "react";
import React, { useEffect, useState, } from "react";
import { useHistory } from "react-router-dom";
import AdminS from "layouts/AdminS";
import Footer from "components/Footer/Footer";
// import { ToastContainer,toast, Zoom, Bounce } from 'react-toastify';
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios"

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Table,
  DropdownButton,
  Dropdown,
  FormControl,
} from "react-bootstrap";
import { createPrinter } from "typescript";

import firebase from "../firebase";

const TMDetails=()=> {

  let history = useHistory();
  
//Stroring Reteriwing Data
const[userData,setUserData]= useState([]);

useEffect(()=>{

  const files = firebase.database().ref("reqforaprooval");
  files.on('value', (snapshot)=>{
    const userList = snapshot.val();
    const dataList = [];
    for(let id in userList){
      dataList.push({id,...userList[id]});
    }
    setUserData(dataList);
    console.log(dataList);
  }) 
    
},[]);
    
const deleteData = (id) =>{
  const delRef = firebase.database().ref("reqforaprooval").child(id);
  delRef.remove();
  alert("Succfully Deleted");
}

const filterData=(datas,searchKey)=>{

  const result = datas.filter(
    (data)=>
    data.NIC.toLowerCase().includes(searchKey) ||
    data.Age.toLowerCase().includes(searchKey)
     //Searching via 
  );
  setUserData(result);
}

const Changestatus = (id,status) =>{
  const files = firebase.database().ref("reqforaprooval").child(id);
  
  let data = {
    Status:status, 
  };
  files.update(data);
  if(status == 1){
    alert("Activated");
  }
  else if(status == 0){
    alert("Deactivated");
  }
  
}
// const successToast = () => {
//   toast("Active TM's",{
//   //className: "custom-toast",
//   draggable: true,
//   position: toast.POSITION.TOP_CENTER,
//   progressClassName: 'success-progress-bar'
//   });
//   };  
  

const handleInput=(e)=>{
  const searchKey = e.currentTarget.value;

  const files = firebase.database().ref("reqforaprooval");
  files.on('value', (snapshot)=>{
    const userList = snapshot.val();
    const dataList = [];
    for(let id in userList){
      dataList.push({id,...userList[id]});
    }
    //
    filterData(dataList, searchKey);
  }) 
    

}
  //   toast.success("YOU SUCCESES");
 
  //  toast.info("YOU HAVE BEEN INFORMATIONALIZED");
 
  //  toast.warn("YOU HAVE BEEN WARNED");
  return (
    <>


<AdminS/>

<br/>


<Container>

  <Row>
    <Col md={{ span: 12, offset: 1 }}>  
    <Container fluid>
<FormControl
    type="search"
    placeholder="Search by NIC" 
    className="mr-2"
    aria-label="Search"
    name="searchQuery"
    onChange={handleInput}
    //onClick={()=>{ handleInput(); successToast(); }}
  />
 <br/>
        <Table className = "text-center" striped bordered hover>
        <thead>
            <tr>
            <th>Index</th>
            <th>Comapny</th>
            <th>NIC</th>
            <th>Email Address</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Address</th>
            {/* <th>City</th>
            <th>Country</th> */}
            <th>Age</th>
            {/* <th>Aboutme</th> */}
            <th colspan="4"><center>Action</center></th>
            </tr>

        </thead>
        <tbody>{userData.map((data, index)=>(
            <tr>
            <td>{index + 1}</td>
            <td>{data.Company}</td>
            <td>{data.NIC}</td>
            <td>{data.Email}</td>
            <td>{data.FirstName}</td>
            <td>{data.LastName}</td>
            <td>{data.Address}</td>
            {/* <td>{data.City}</td>
            <td>{data.Country}</td> */}
            <td>{data.Age}</td>
            <td>
            <center>
            <Button onClick={()=>Changestatus(data.id,1)} variant="success" className = "ml-2 mr-0" size="" active>
              Activate 
            </Button>{' '}</center></td>
            
            <td>
            <center>
            <Button onClick={()=>Changestatus(data.id,0)} className = "ml-2 mr-0" variant="danger" size="" active>
              Deactivate 
            </Button>
            </center></td>
            
            <td>
            <center>
            <Button href={`/UpdateAccDetails/${data.id}`} className = "mx-2" variant="primary" size="" active>
              Edit
            </Button>{' '}</center></td>
            
            <td>
            <center>
            <Button onClick={()=>deleteData(data.id)} className = "ml-2 mr-0" variant="primary" size="" active>
              Delete
            </Button>
            </center></td>
            

            </tr>
            ))}
        </tbody>
        </Table>
        {/* <ToastContainer /> */}
        </Container>

        
      </Col>
  </Row>

  
</Container>


<Footer /> 
        </>



        ) ;
    }
export default TMDetails;